import { ICustomer } from './customer'
import { FormFieldType } from 'src/enums'
import { IDeviation, IScheduledTaskDeviation } from './deviation'
import { IScheduledService } from './locality-frequency'
import { IUser } from './user'

export enum SchemaType {
  FormSchema = 0,
  Checklist = 1,
}

export interface IFormSchemaGeneric {
  name: string
  description: string
  hasVideoUpload: boolean
  isActive: boolean
  schemaType?: SchemaType
}

export interface IFormSchema extends IFormSchemaGeneric {
  id?: number
  customer?: ICustomer
  customerId: number
  versions: IFormSchemaVersion[]
}

export interface ICustomerFormSchema {
  id?: number
  name: string
  description: string
  schemaType?: SchemaType
  version: IFormSchemaVersion
  mainComponentTypeIds?: number[]
}

export interface IFormSchemaDto extends IFormSchemaGeneric {
  id?: number
  formSchemaVersion?: IFormSchemaVersion
  formSchemaReports?: IFormSchemaReport[]
}

export interface IFormSchemaVersion {
  id?: number
  layout: string
  version: number
  formSchemaId?: number
  formSchema?: IFormSchema
  reports?: IFormSchemaReport[]
}

export interface IFormSchemaReport {
  id?: number
  formSchemaVersionId?: number
  formSchemaVersion?: IFormSchemaVersion
  values: string
  type: formSchemaReportTypes
  deviationId?: string
  localityFrequencyId?: number
  groupId?: string
  mainComponentId?: string
  deviation?: IDeviation
  service?: IScheduledService
  createdByUser?: IUser
  createdAt?: string
  createdByUserId?: string
  scheduledTaskId?: number
  localityId?: number
  isDraft?: boolean
  draftCaption?: string
  scheduledTask?: {
    scheduledTaskDeviations?: IScheduledTaskDeviation[]
  }
  /** Form schema report deviations to be created along with the report */
  formSchemaReportDeviations?: IFormSchemaReportDeviationDto[]
}

export interface IMoveFormSchemaReportDto {
  targetId: number
  values?: string
  publishDraft?: boolean
  draftCaption?: string
}

export interface IFormSchemaReportDeviationDto {
  deviation: ICreateDeviationDto
  checklistFieldId?: string
  checklistItemId?: string
}

export interface ICreateDeviationDto extends IDeviation {
  tempId?: string
}

export interface IFormSchemaReportValues {
  values: string
  layout: string
  deviations?: IFormSchemaReportDeviation[]
}

export interface IFormSchemaReportDeviation {
  deviationId: number
  title: string
  description?: string
  checklistFieldId?: string
  checklistItemId?: string
  status: number
}

export enum formSchemaReportTypes {
  Document = 1,
  Deviation = 2,
  Task = 3,
  Service = 4,
  MainComponent = 5,
  Mooring = 6,
  Locality = 7,
  Position = 8,
}
export interface IFormSchemaColumnOption {
  value: string
  label: string
}
export interface IFormSchemaColumn {
  name: string
  type: FormFieldType
  identifier: string
  options?: IFormSchemaColumnOption[]
  content?: string
}

export interface IMoveReportTarget {
  id: EntityId
  label: string
  secondaryLabel?: string
}

export interface IMoveReportDestinationPickerProps {
  customerId: EntityId
  excludedId?: EntityId
  localityId?: EntityId
  selected?: IMoveReportTarget
  onSelect: (target: IMoveReportTarget) => void
}
